import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	clearAllButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	clearAllButtonText: {
		id: 'jql-builder-basic.common.clear-filters-button-text',
		defaultMessage: 'Clear all',
		description: 'The text for the clear all filters button in refinement bar',
	},
});
